/**
 * Unidad de Valor Real.
 */
export var COU = {
  code: 'COU',
  base: 10,
  exponent: 2
};